import type { IntegrityStatus } from "~utils/moduleIntegrity";

import type { ItemWithTrackingProps } from "./ItemWithTracking";

export default function integrityCheck(
    props: ItemWithTrackingProps
): IntegrityStatus {
    const messages: IntegrityStatus = [];

    if (!props.containerTag) messages.push("Missing container tag");
    if (!props.className) messages.push("Missing class name");
    if (!props.item) messages.push("Missing item");

    return messages;
}
